<template>
    <div v-if="asyncDataStatus_ready">

    <v-row justify="space-between">
      <v-col cols="6" md="3">
        <v-text-field
          v-if="this.users.length"
          placeholder="Išči..."
          append-icon="mdi-search"
          v-model="filter"
          @keydown.esc="filter=''"
        ></v-text-field>
      </v-col>
      <v-col cols="auto">
        <v-btn
          color="#0F998E"
          class="white--text"
          @click="$router.push({name: userNewRouteName})"
        >
          Nov uporabnik
          <v-icon right dark>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row v-if="this.users.length">
      <v-col>
        <v-simple-table
          fixed-header
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Oznaka uporabnika
                </th>
                <th class="text-left">
                  Tip uporabnika
                </th>
                <th class="text-left">
                  Davčna številka
                </th>
                <th class="text-left">
                  Pin
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="user in filteredUsers"
                :key="user.id"
              >
                <td :style="{'border-left': `5px solid red`}">{{ user.moniker }}</td>
                <td :style="{color: user.user_type_name ? '#000' : '#ff000070'}">{{user.user_type_name || 'drugo'}}</td>
                <td :style="{color: user.tax_number ? '#000' : '#ff000070'}">{{user.tax_number || 'ni določena'}}</td>
                <td :style="{color: user.plain_pin_code ? '#000' : '#ff000070'}">{{user.plain_pin_code || 'ni določen'}}</td>
                <td class="text-right">
                  <ButtonActionEdit @click="$router.push({name: userEditRouteName, params: { id: user.id }})" />
                  <ButtonActionDelete @click="showDeleteUserModal = true; deleteUser = user" />
                  <ButtonActionResetPass @click="$router.push({name: userResetPassRouteName, params: { id: user.id }})" />
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row
      v-else
    >
      <v-col cols="12">
        <p class="text-center">
          Ni rezultatov iskanja. Za dodajanje novega artikla uporabite gumb desno zgoraj.
        </p>
      </v-col>
    </v-row>

    <!-- <v-row v-if="this.users.length">
      <v-col
        cols="12" md="6" xl="4"
        v-for="user of filteredUsers" :key="user.id"
      >
        <UserCard
          :user="user"
          @edit="$router.push({name: userEditRouteName, params: { id: user.id }})"
          @delete="showDeleteUserModal = true; deleteUser = user"
          @resetPass="$router.push({name: userResetPassRouteName, params: { id: user.id }})"
        />
      </v-col>
    </v-row>
    <v-row
      v-else
    >
      <v-col cols="12">
        <p class="text-center">
          Ni rezultatov iskanja. Za dodajanje novega uporabnika uporabite gumb desno zgoraj.
        </p>
      </v-col>
    </v-row> -->

    <ConfirmDialog
      title="Brisanje uporabnika"
      text="Ali ste prepričani, da želite izbrisati uporabnika? Podatki bodo trajno izbrisani."
      okBtnText="Briši"
      v-model="showDeleteUserModal"
      @confirmed="remove(deleteUser)"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import { siIncludes } from '@/utils/str'
import { loadItems, deleteItem } from '@/utils/crudFunctions'
import UserCard from '@/components/UserCard'
import ConfirmDialog from '@/components/ConfirmDialog'
import { objectToArray } from '@/utils/object'
import ButtonActionEdit from '@/components/ButtonActionEdit'
import ButtonActionDelete from '@/components/ButtonActionDelete'
import ButtonActionResetPass from '@/components/ButtonActionResetPass'

export default {
  components: {
    UserCard,
    ConfirmDialog,
    ButtonActionEdit,
    ButtonActionDelete,
    ButtonActionResetPass
  },
  mixins: [
    asyncDataStatus
  ],
  data () {
    return {
      filter: '',
      showDeleteUserModal: false,
      deleteUser: null
    }
  },
  computed: {
    ...mapGetters('auth', ['childCompanyUserIsTaken']),
    users () {
      return objectToArray(this.$store.state.users.items)
    },
    filteredUsers () {
      return this.users
        .filter(user => {
          // If filter is empty, show all users (including PIN-only users)
          if (!this.filter) return true
          // Otherwise, filter by name or moniker
          return [user.complete_name, user.moniker]
            .some(this.matchFilter)
        })
        .sort((a, b) => {
          if (a.user_type_name < b.user_type_name) return -1;
          if (a.user_type_name > b.user_type_name) return 1;

          return a.plain_pin_code - b.plain_pin_code;
        });
    },
    userNewRouteName () {
      return this.childCompanyUserIsTaken ? 'MyCompanyUsersNew' : 'UsersNew'
    },
    userEditRouteName () {
      return this.childCompanyUserIsTaken ? 'MyCompanyUsersEdit' : 'UsersEdit'
    },
    userResetPassRouteName () {
      return this.childCompanyUserIsTaken ? 'MyCompanyUsersResetPass' : 'UsersResetPass'
    }
  },
  methods: {
    ...mapActions('users', ['loadItems', 'deleteItem']),
    matchFilter (testString) {
      if (!testString) return false
      return siIncludes({ haystack: testString, needle: this.filter })
    },
    remove (user) {
      if (user) {
        deleteItem(user, this)
      }
    }
  },
  created () {
    loadItems(this)
  }
}
</script>
